// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stylishbordertop{background:var(--tenant-gradient-header)}`, "",{"version":3,"sources":["webpack://./src/components/pages/Payouts/NewCreateManualPayout/FakeTopBar.css"],"names":[],"mappings":"AAAA,kBACE,wCACF","sourcesContent":[".stylishbordertop {\n  background: var(--tenant-gradient-header);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
